import React, { Component } from 'react'
import AvatarComponent from "react-rounded-image";
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
export default class UploadAvatar extends Component {
    constructor(props) {
        super(props);
        this.state ={
            file: null,
            avatarImage:""
        };
        //this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.uploadAvatar=this.uploadAvatar.bind(this)
        this.updateProfile=this.updateProfile.bind(this)
    }
    updateProfile=()=>{
        this.setState({
          avatarImage:localStorage.getItem("avatar")
        })
      }
      componentWillMount(){
        this.setState({
          avatarImage:localStorage.getItem("avatar")
        })
      }
    onChange(e) {
        this.setState({file:e.target.files[0]});
        //console.log(e.target.files[0])
        this.props.uploadAvatar(e.target.files[0])
        setTimeout(() => {
            this.updateProfile()
          }, 300);
    }
    uploadAvatar=()=>{
        this.props.uploadAvatar(this.state.file)
    }
    render() {
        return (
            <div style={{marginTop:"25px",flexGrow:1}} >
                <Grid container  >
                    <Grid item sm={4}>
                    </Grid>
                    <Grid item sm={4}>
                        <div style={{width:"100%",marginLeft:"10%"}}>
                            <AvatarComponent
                            image={"data:image/png;base64," +this.state.avatarImage }
                            roundedColor="#151515"
                            imageWidth="130"
                            imageHeight="130"
                            roundedSize="2"
                            />  
                        </div>
                                              
                    </Grid>
                    <Grid item sm={3}> 
                        <div style={{marginTop:"50%", marginLeft:"-40%"}}>
                        <Tooltip title="Edit">
                            <IconButton aria-label="Edit"
                            onClick={e => {
                                this.refs['file-upload'].click()
                              }}
                            >
                                <EditIcon />
                            </IconButton>  
                        </Tooltip>                            
                        </div>               
                    </Grid>
                </Grid>
            <input type="file" name="myImage" onChange= {this.onChange} ref={"file-upload"} style={{display:"none"}}/>
            </div>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/profile/UploadAvatar.js